import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import GridCellErrorBoundary from './GridCellErrorBoundary';
import Cell from './V5Gadget/Matrix/Cell';
import { StatusIcon } from './DriverAX/components/BonusStatusCell';

const BooleanIconCell = (props: ICellRendererParams) => {
  const { value } = props;
  if (typeof value !== 'boolean') {
    return <Cell />;
  }

  return (
    <Cell>
      <StatusIcon passed={value} />
    </Cell>
  );
};

const Gate = (params: ICellRendererParams) => (
  <GridCellErrorBoundary
    params={params}
    childComponent={<BooleanIconCell {...params} />}
  />
);

export default Gate;
